import React from "react";
import { Message, theme, Text } from "@clearabee/ui-library-native";
import { useTranslation } from "react-i18next";
import { Platform } from "react-native";

interface PostcodeResultMessageProps {
  postcode?: string;
  hasResults: boolean;
  invalidPostcode: boolean;
}

export const PostcodeResultMessage = ({
  postcode,
  hasResults,
  invalidPostcode,
}: PostcodeResultMessageProps): React.ReactElement => {
  const [translate] = useTranslation();
  const isWeb = Platform.OS === "web";

  return (
    <>
      {invalidPostcode && (
        <Message
          type="error"
          background
          styles={{
            marginHorizontal: "auto",
            marginBottom: theme.spacing.large,
            zIndex: -1,
            backgroundColor: theme.colors.negative.base,
          }}
          color="light"
        >
          {translate("hwa.components.postcodeResultMessage.invalidPostcode")}
        </Message>
      )}
      {!invalidPostcode && !postcode && (
        <Text
          styles={{
            marginBottom: theme.spacing.large,
            textAlign: "center",
          }}
          color={isWeb ? "light" : "brand"}
        >
          {translate("hwa.components.postcodeResultMessage.enterPostcode")}
        </Text>
      )}
      {!invalidPostcode && !!postcode && hasResults && (
        <Text
          styles={{
            marginBottom: theme.spacing.large,
            textAlign: "center",
          }}
          color={isWeb ? "light" : "brand"}
        >
          {translate("hwa.components.postcodeResultMessage.showPostcodePrices")}{" "}
          <Text
            styles={{ textTransform: "uppercase" }}
            color={isWeb ? "accent" : "warning"}
          >
            &#34;{postcode}&#34;
          </Text>
        </Text>
      )}
      {!invalidPostcode && !!postcode && !hasResults && (
        <Text
          styles={{
            marginBottom: theme.spacing.large,
            textAlign: "center",
          }}
          color={isWeb ? "light" : "brand"}
        >
          {translate(
            "hwa.components.postcodeResultMessage.unavailablePostcode",
          )}{" "}
          <Text
            styles={{ textTransform: "uppercase" }}
            color={isWeb ? "accent" : "warning"}
          >
            &#34;{postcode}&#34;
          </Text>
        </Text>
      )}
    </>
  );
};
